import styles from "../OfficeStaffInformation.module.scss";
import Text from "components/Text";
import defaultImage from "assets/images/staff-default.svg";
import callIcon from "assets/images/call-icon.svg";
import locationPin from "assets/images/pin-icon.svg";

const OfficeCardView = ({ office, officeLength }) => {
  return (
    <div className={styles["office-card"]} key={office.id}>
      <div className={ styles["image"]}>
        <img
          src={office?.officeImage ? office?.officeImage : defaultImage}
          alt=""
          onError={(e) => {
            e.target.src = defaultImage;
          }}
        />
      </div>
      <div className={""}>
        <Text color="#587E85" size="16px" weight="600">
          {office?.name || office?.officeName || null}
        </Text>
        {office?.address && (
          <Text color="#6F7788" size="12px" weight="600">
            <a
              href={"https://maps.google.com/maps?q=" + office?.address}
              className={`main-text-color  ${styles["company-directoty-detail"]}`}
              target="_blank"
            >
              <img src={locationPin} alt="" className="me-xxs" />{" "}
             <span> {office?.address}</span>
            </a>
          </Text>
        )}
        {office?.contactNumber && (
          <Text color="#6F7788" size="12px" weight="600" underline>
            <a
              href={`tel:+` + office?.contactNumber}
              className={`main-text-color  ${styles["company-directoty-detail"]}`}
            >
              <img src={callIcon} alt="" className="me-xxs" />{" "}
              <span>{office?.contactNumber}</span>
            </a>
          </Text>
        )}
      </div>
    </div>
  );
};
export default OfficeCardView;
